export enum StateReview {
	REVISED = 'REVISED',
	NOT_REVIEWED = 'NOT_REVIEWED',
}
